import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import BrandMark from './BrandMark';
import Icon from './Icons';
import { NAV_SECTIONS } from '../data/catalog';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('');

  useEffect(() => {
    const onScroll = () => {
      const offsets = NAV_SECTIONS.map(({ id }) => {
        const el = document.getElementById(id);
        if (!el) return { id, distance: Infinity };
        return { id, distance: Math.abs(el.getBoundingClientRect().top - 120) };
      });
      const closest = offsets.reduce((a, b) => (a.distance < b.distance ? a : b));
      if (closest.distance !== Infinity) setActive(closest.id);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (id) => {
    scrollTo(id);
    setOpen(false);
  };

  return (
    <nav className="nav">
      <div className="nav-inner">
        <button className="nav-brand" onClick={() => go('home')} aria-label="JbnWorks home">
          <BrandMark />
          <span className="brand-name">JbnWorks</span>
        </button>

        <ul className="nav-links">
          {NAV_SECTIONS.map(({ id, label }) => (
            <li key={id}>
              <button className={active === id ? 'active' : ''} onClick={() => go(id)}>
                {label}
              </button>
            </li>
          ))}
        </ul>

        <button className="nav-cta" onClick={() => go('contact')}>Start a Conversation</button>

        <button className="nav-toggle" aria-label="Toggle menu" onClick={() => setOpen((v) => !v)}>
          <Icon name={open ? 'close' : 'menu'} />
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            className="nav-mobile"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.22 }}
          >
            <div className="nav-mobile-inner">
              {NAV_SECTIONS.map(({ id, label }) => (
                <button key={id} onClick={() => go(id)}>{label}</button>
              ))}
              <button className="nav-cta" onClick={() => go('contact')}>Start a Conversation</button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
